var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgCloseAlt = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m7 8.054-5.073 5.073a.726.726 0 0 1-.522.212.708.708 0 0 1-.532-.212.718.718 0 0 1-.217-.527c0-.206.072-.382.217-.527L5.946 7 .873 1.927a.726.726 0 0 1-.212-.522.708.708 0 0 1 .212-.532A.718.718 0 0 1 1.4.656c.206 0 .382.072.527.217L7 5.946 12.073.873a.726.726 0 0 1 .522-.212.707.707 0 0 1 .532.212c.145.145.217.32.217.527a.718.718 0 0 1-.217.527L8.054 7l5.073 5.073c.138.138.21.313.212.522a.707.707 0 0 1-.212.532.718.718 0 0 1-.527.217.718.718 0 0 1-.527-.217L7 8.054Z",
  fill: "currentColor"
})));

export default SvgCloseAlt;